/**
 * The attention ping (static/audio/attention.wav), shared by the leasing attention toasts
 * (agent-ws.js) and the General text toast (sms-envelope.js). Callers pass the sound URL from
 * their page's `data-attention-sound`. One <audio> element per URL, so unlocking it once (a muted
 * play on the first click or key press, which browsers require before audio may autoplay)
 * unlocks it for every caller.
 */

var players = Object.create(null);
var unlocked = Object.create(null);

function player(url) {
    if (!players[url]) {
        players[url] = new Audio(url);
        players[url].preload = 'auto';
    }
    return players[url];
}

export function playAttentionSound(url) {
    if (!url) return;
    var audio = player(url);
    audio.currentTime = 0;
    var p = audio.play();
    if (p && p.catch) p.catch(function () {});
}

export function unlockAudio(url) {
    if (!url || unlocked[url]) return;
    var audio = player(url);
    audio.muted = true;
    var p = audio.play();
    if (p && p.then) {
        p.then(function () {
            audio.pause();
            audio.muted = false;
            unlocked[url] = true;
        }).catch(function () {});
    }
}
